import type { StringUnion } from '../../../../typescript';
import { BASE_URLS, BaseUrl } from '../../base-urls';

const isResearchV2BaseUrl = (baseUrl?: StringUnion<BaseUrl>) => {
    if (baseUrl === 'research-api-v2') {
        return true;
    }
    return false;
};

const isResearchV2Url = (url: string, baseUrl?: StringUnion<BaseUrl>) => {
    if (isResearchV2BaseUrl(baseUrl) || url?.includes(BASE_URLS['research-api-v2'] as string)) {
        return true;
    }
    return false;
};

export { isResearchV2BaseUrl, isResearchV2Url };
